import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useSelector } from 'react-redux'
import AttrDisplayProps from './AttrDisplayProps'
import {
  faInfoCircle,
  faQuestion,
  faQuestionCircle,
  faSearch,
} from '@fortawesome/free-solid-svg-icons'
import DynamicFieldMultiple from '../dynamic-field-multiple/DynamicFieldMultiple'
import {
  getAttributeUniqueName,
  CertificateGroupEnum,
} from '../../../../../../utils/constants/certificate.constants'
import { selectCopyState } from '../../../../../../features/createCertificate/createCertificateSlice'
import { Tooltip } from 'primereact/tooltip'
import { Checkbox } from 'primereact/checkbox'
import { Button } from 'primereact/button'
import clsx from 'clsx'
import CertificateCustomerNameLookup from '../../certificate-customer-name-lookup/CertificateCustomerNameLookup'
import { useState } from 'react'

export type AttrDisplaySingleSelectMultipleProps = {
  shouldViewEditStanndardDetailsDisplay: any
  onContinue: any
  formDisplay: any
  isEditCert: any
  isModifyCert: any
  hasRevisions: any
  setDropdownRef: any
  setProductOwnerFilter: any
  certificateStatus: any
  isCertNameOnMaxLength: any
  classes: any
  certifyFields: Array<string>
  decisionFields: Array<string>
  recommendFields: Array<string>
  isFieldMounted: any
  setIsFieldMounted: any
  disableAutoGenerate: any
  isAutoGenerate: any
  handleAutoGenerate: any
  filterListener: any
  setFilterListener: any
  closeLookupSignal: any
} & AttrDisplayProps
export default function AttrDisplaySingleSelectMultiple({
  attrDisplay,
  attributeFlatList,
  certGroupIndex,
  setFormValidityMessages,
  setFormValues,
  setIsShowNoStandard,
  formValues,
  selectedScheme,
  validityMessage,
  // extended props
  shouldViewEditStanndardDetailsDisplay,
  onContinue,
  formDisplay,
  isEditCert,
  isModifyCert,
  hasRevisions,
  setDropdownRef,
  setProductOwnerFilter,
  certificateStatus,
  isCertNameOnMaxLength,
  classes,
  certifyFields,
  decisionFields,
  recommendFields,
  isFieldMounted,
  setIsFieldMounted,
  disableAutoGenerate,
  isAutoGenerate,
  handleAutoGenerate,
  fieldChangeListener,
  closeLookupSignal,
}: AttrDisplaySingleSelectMultipleProps) {
  const [isLookupShow, setIsLookupShow] = useState(false)
  const [filterListener, setFilterListener] = useState({
    field: null,
    value: null,
    index: null,
  })

  const isEditModify = isModifyCert || isEditCert
  const { certificateNumber } = useSelector(selectCopyState)

  const standardFields = [
    getAttributeUniqueName(CertificateGroupEnum.Certificate, 'standard'),
    getAttributeUniqueName(CertificateGroupEnum.Certificate, 'secondaryStandard'),
  ]
  const isEditableStandardField =
    isEditModify && standardFields.includes(attrDisplay.attribute.attribute_unique_name)

  const isDisableEditPsn =
    isEditModify &&
    attrDisplay.attribute.attribute_unique_name ===
    getAttributeUniqueName(CertificateGroupEnum.Certificate, 'ownerReference')

  const isCertificateOwnerField =
    attrDisplay.attribute.attribute_unique_name ===
    getAttributeUniqueName(CertificateGroupEnum.PartyType, 'applicant')

  const listener = fieldChangeListener
    ? fieldChangeListener[attrDisplay.attribute.attribute_unique_name]
    : undefined

  const handleSearchCustomer = (e: any) => {
    if (isDisableEditPsn) return
    const listenerField = attrDisplay.attribute.attribute_unique_name
    setFilterListener({ field: listenerField, value: null, index: null })
    setIsLookupShow(true)
  }

  return (
    <>
      <div className="dynamic-fld-lbl">
        <span>{attrDisplay.attribute.display_name}</span>
        {attrDisplay.attribute.is_required && <span className="text-red"> * </span>}
        {attrDisplay.attribute.attribute_unique_name === 'certificate_ownerReference' && (
          <span
            className={`tooltip-info-target-${attrDisplay?.attribute?.attribute_unique_name}`}
            style={{ marginLeft: '5px' }}
          >
            <FontAwesomeIcon
              className={`${classes['psn-info-icon']}`}
              icon={faInfoCircle}
              size="sm"
            />

            <Tooltip
              target={`.tooltip-info-target-${attrDisplay?.attribute?.attribute_unique_name}`}
              position="right"
            >
              Product Owner Party Site Number will be inherited into the Model Search Party Site
              Number field
            </Tooltip>
          </span>
        )}

        {attrDisplay.attribute?.help_text != '' && (
          <span
            className={`tooltip-target-${attrDisplay?.attribute?.attribute_unique_name}`}
            style={{ marginLeft: '5px' }}
          >
            <FontAwesomeIcon
              className={`${classes['tooltip-icon']}`}
              icon={faQuestionCircle}
              size="sm"
            />

            <Tooltip
              target={`.tooltip-target-${attrDisplay?.attribute?.attribute_unique_name}`}
              position="right"
            >
              {attrDisplay?.attribute?.help_text}
            </Tooltip>
          </span>
        )}

        {attrDisplay.attribute.is_allow_search && (
          <span
            className={clsx(
              classes['cl-container'],
              isDisableEditPsn ? classes['cl-container-disabled'] : ''
            )}
            onClick={(e: any) => handleSearchCustomer(e)}
          >
            <FontAwesomeIcon className={`${classes['tooltip-icon']}`} icon={faSearch} size="sm" />
            <Button
              className={clsx(classes['cl-search-btn'], 'p-button-link')}
              disabled={isDisableEditPsn}
            >
              <span>Search</span>
            </Button>
          </span>
        )}
      </div>
      <DynamicFieldMultiple
        setIsShowNoStandard={setIsShowNoStandard}
        field={attrDisplay.attribute}
        isRequired={attrDisplay.attribute.is_required}
        formValues={formValues}
        attributeFlatList={attributeFlatList}
        setFormValues={setFormValues}
        setFormValidityMessages={setFormValidityMessages}
        formDisplay={formDisplay}
        certGroupIndex={certGroupIndex}
        fieldIndex={0}
        selectedScheme={selectedScheme}
        fieldType={attrDisplay.type}
        isEditCert={isEditCert}
        isModifyCert={isModifyCert}
        hasRevisions={hasRevisions}
        isAutoGenerate={isAutoGenerate}
        setDropdownRef={setDropdownRef}
        setProductOwnerFilter={setProductOwnerFilter}
        showMultiSelectValuesTooltip={standardFields.includes(
          attrDisplay.attribute.attribute_unique_name
        )}
        isFieldDisabled={
          standardFields.includes(attrDisplay.attribute.attribute_unique_name) && isEditModify
        }
        certifyFields={certifyFields}
        decisionFields={decisionFields}
        recommendFields={recommendFields}
        isFieldMounted={isFieldMounted}
        setIsFieldMounted={setIsFieldMounted}
        onFieldChange={(value: any) => {
          if (listener) {
            listener(value)
          }
        }}
        filterListener={filterListener}
        setFilterListener={setFilterListener}
        validityMessage={validityMessage}
      />

      {isCertificateOwnerField && (
        <div className={classes['certificate-owner-default-note']}>Note: Defaults to Sold To</div>
      )}

      {attrDisplay.attribute.attribute_unique_name ===
        getAttributeUniqueName(CertificateGroupEnum.Certificate, 'certificateName') &&
        !(isModifyCert || isEditCert) &&
        !certificateNumber && (
          <div
            className={
              disableAutoGenerate
                ? classes['auto-generate-number-chkb-disabled']
                : classes['auto-generate-number-chkb']
            }
          >
            <Checkbox
              disabled={disableAutoGenerate}
              className={classes['auto-generate-disabled']}
              onChange={e => handleAutoGenerate(e.checked)}
              checked={isAutoGenerate}
            />
            <span style={{ paddingLeft: '5px' }}>Auto Generate</span>

            <span
              className={`tooltip-target-${attrDisplay?.attribute?.attribute_unique_name}-chk`}
              style={{ marginLeft: '5px' }}
            >
              <FontAwesomeIcon
                className={`${classes['tooltip-icon']}`}
                icon={faQuestionCircle}
                size="sm"
              />

              <Tooltip
                target={`.tooltip-target-${attrDisplay?.attribute?.attribute_unique_name}-chk`}
                position="right"
                disabled={disableAutoGenerate}
              >
                Selecting this option will use the certificate number auto generated by CNG tool
              </Tooltip>
            </span>
          </div>
        )}

      {attrDisplay.attribute.attribute_unique_name ===
        getAttributeUniqueName(CertificateGroupEnum.Certificate, 'certificateName') &&
        isCertNameOnMaxLength && (
          <span className="text-red">
            {' '}
            You have exceeded the maximum character length (150 characters).{' '}
          </span>
        )}

      {isEditableStandardField && (
        <div className={classes['view-edit-standard-details-note']}>
          Note: Standard value may be updated in the Product Standard field of Products and
          Evaluations section
        </div>
      )}

      <CertificateCustomerNameLookup
        isLookupShow={isLookupShow}
        setIsLookupShow={setIsLookupShow}
        setFormValues={setFormValues}
        formValues={formValues}
        listener={filterListener}
        setListener={setFilterListener}
        closeSignal={closeLookupSignal}
      />
    </>
  )
}
